export const DRIVER_BYPASS_URL = '/driver-bypass';
export const DRIVER_LICENSE_URL = '/driver-license';
export const DRIVER_ADD_URL = '/driver-add';
export const VEHICLE_BYPASS_URL = '/vehicle-bypass';
export const VEHICLE_URL = '/vehicle';
export const VEHICLE_ADD_URL = '/vehicle-add';
export const VEHICLE_EDIT_URL = '/vehicle-edit';
export const DRIVER_EDIT_URL = '/driver-edit';
export const FREIGHT_ADD_URL = '/add-freight';
export const WELCOME_ADDRESS_URL = '/company-details';
export const QUOTE = '/quote';
export const POLICY = '/policy';
export const CONFIRM = '/confirm';
export const COMPANY_START = '/company-start';
